import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.validateInput = this.validateInput.bind(this);
    this.textareaTarget.addEventListener("input", this.validateInput);
  }

  disconnect() {
    this.textareaTarget.removeEventListener("input", this.validateInput);
  }

  validateInput(event) {
    const input = event.target.value;
    const validatedInput = input.replace(/[^a-zA-Z0-9.! \n\räöüÄÖÜßéèêëàâäôùûüïîçÉÈÊËÀÂÄÔÙÛÜÏÎÇòóàèìíùúÒÓÀÈÌÍÙÚ]/g, "");
    
    if (input !== validatedInput) {
      // Invalid characters were entered - replace with validated text
      event.target.value = validatedInput;
      
      // Optional: Add visual feedback for the user
      this.showValidationMessage();
    }
  }

  showValidationMessage() {
    // Optional: Can implement visual feedback here (like a flash message)
    // For example, briefly highlight the field in red
    this.textareaTarget.classList.add("border-red-500");
    setTimeout(() => {
      this.textareaTarget.classList.remove("border-red-500");
    }, 500);
  }
}
